import React from "react";

const StatCard = ({ title, value, icon: Icon, color = "blue", trend }) => {
  return (
    <div className={`stat-card stat-card-${color}`}>
      <div className="stat-card-header">
        <span className="stat-card-title">{title}</span>
        {Icon && (
          <div className={`stat-card-icon-container stat-card-icon-${color}`}>
            <Icon size={20} />
          </div>
        )}
      </div>
      <div className="stat-card-body">
        <h3 className="stat-card-value">{value}</h3>
        {trend && (
          <div className="stat-card-trend">
            <span className={`trend-badge trend-badge-${trend.type}`}>
              {trend.value}
            </span>
            <span className="trend-label">{trend.label}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
